import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nl',
  templateUrl: './nl.component.html',
  styleUrls: ['./nl.component.scss']
})
export class NlComponent implements OnInit {

  constructor(private title: Title) {
    this.title.setTitle('کارگزاری آبان | عضویت خبرنامه ')
  }

  ngOnInit(): void {
    const footer = document.querySelector('app-footer');
    const navbar = document.querySelector('app-navbar');
    footer['style'].display = 'none';
    navbar['style'].display = 'none';

  }

  submit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    const { name, last_name, email, phone } = form.value;
    // const _subject = `${form.value.subject}: ${form.value.firstname} ${form.value.lastname}`;
    const body = `<p style=""direction: rtl;"">
    نام و نام خانوادگی: ${name} ${last_name} </p><p style=""direction: rtl;"">
    تلفن همراه: ${phone}
    </p><p style=""direction: rtl;"">
    آدرس ایمیل: ${email}
    </p>`

    window['Email'].send({
      Host: environment.email.host,
      Username: environment.email.username,
      Password: environment.email.password,
      To: '',
      From: email,
      Subject: 'عضویت خبرنامه',
      Body: body
    }).then(
      message => alert('عضویت شما با موفقیت انجام شد')
    );

  }

}
